/*
   Displays the Job Templates Overlay
   where user can view template titles
   and view templates for those titles.

   Can also use Job template for description for a job.
*/

import React, { Component } from "react";

import {
   Modal,
   ModalHeader,
   ModalBody,
   ModalFooter,
   Button,
   Row,
   Col,
} from "reactstrap";

import JobTemplateList from "./JobTemplateList";
import JobTemplateDisplay from "./JobTemplateDisplay";

class JobDescriptionsModal extends Component {

   constructor(props) {
      super(props);
      this.state = {
         selectedTemplate: null, // holds selected template from the left side list
         templateDetails: null // holds full details about selected template : id, description and title
      };
      this.onTemplateSelection = this.onTemplateSelection.bind(this);
      this.selectCurrentTemplate = this.selectCurrentTemplate.bind(this);
      this.onCurrentTemplateLoad = this.onCurrentTemplateLoad.bind(this);
      this.onModalOpened = this.onModalOpened.bind(this);
   }

   componentDidMount() {
   }

   componentWillUnmount() {
   }

   onTemplateSelection(template) {
      this.setState({
         selectedTemplate: template
      });
   }

    // passes back description of template to be used by parent
   selectCurrentTemplate() {
      if (this.props.onUseDescription) {
         this.props.onUseDescription(
            this.state.templateDetails.description
         );
      }
   }

    // resets selected template when modal is opened
   onModalOpened() {
      this.setState({
         selectedTemplate: null
      });
   }

    // loads current selected template details from the child JobTemplateDisplay
   onCurrentTemplateLoad(template) {
      this.setState({
         templateDetails: template
      });
   }

   render() {
      const { isVisible } = this.props;
      const { selectedTemplate } = this.state;

      return (
         <Modal
            isOpen={isVisible}
            toggle={this.props.toggle}
            className={this.props.className}
            onOpened={this.onModalOpened}
            size="xl"
         >
            <ModalHeader toggle={this.props.toggle}>
               Similar Job Title Templates
            </ModalHeader>

            <ModalBody>
               <p>
                  Our library of job descriptions consists of hundreds of templates. All of our job description templates are free, simple and easy to customize to meet your specific needs. Just search for a job description template or select one from a category below, customize it or leave it as is, and publish your job.
               </p>
                  <div className="clearfix">
                     <Row>
                        <Col xs="3">
                           <JobTemplateList
                              search={this.props.search}
                              onTemplateSelection={this.onTemplateSelection}
                           />
                        </Col>
                        <Col xs="9">
                           { isVisible ?
                              <JobTemplateDisplay
                                 templateId={selectedTemplate ? selectedTemplate.id : null}
                                 onTemplateLoad={this.onCurrentTemplateLoad}
                              />
                              :
                              <></>
                           }
                        </Col>
                     </Row>
                  </div>
               </ModalBody>
               <ModalFooter>
                  <Button
                     className='btn-rounded btn-dark-orange btn-lg'
                     disabled={!selectedTemplate}
                     onClick={this.selectCurrentTemplate}
                  >
                     Select Template
                  </Button>
               </ModalFooter>
            </Modal>
         )
   }
}

export default JobDescriptionsModal;
